import backendApiClient from './backend';
import ApiClient from './client';
import loggerService from '../logger.service';

import { getEnv } from '@/constants';
import store from '@/store';
class MattermostApiClient extends ApiClient {
  token: string = '';

  authTokenFetchRetriesCount: number = 0;
  maxAuthTokenFetchRetries: number = 20;

  tokenFetchPromise: any = null;

  constructor() {
    super(getEnv('VUE_APP_API_MATTERMOST') || '');
    this.maxAuthRetries = 5;
  }

  get authToken() {
    return store.state.event.useGCAuth && store.state.event.isNewLoginFlowEnabled
      ? store.state.user.accessToken
      : this.token;
  }

  get isJwtAuth(): boolean {
    return !!(store.state.event.useGCAuth && store.state.event.isNewLoginFlowEnabled);
  }

  onUnauthorized(forced: boolean = false, error?: string) {
    loggerService.log('Fetching mm token. Is forced mode: ', forced);
    const i18n = window.i18n ?? { global: { t: (k: string) => k } };

    if (!store.state.user.accessToken) {
      loggerService.log('User is not logged in mm token is not being fetched');
      return false;
    }

    // If gc_auth is enabled, refresh Cognito/GCAuth token
    if (store.state.event.useGCAuth && store.state.event.isNewLoginFlowEnabled) {
      loggerService.log('Using gc_auth, refreshing Cognito/GCAuth token');
      return store.dispatch('fetchAccessToken', { isUnauthorized: true, error });
    }

    // Legacy flow - fetch Mattermost token
    loggerService.log('Fetching mm token. Is forced mode: ', forced);

    if (this.authTokenFetchRetriesCount > this.maxAuthTokenFetchRetries) {
      loggerService.warn(
        `Because of repeated mattermost auth token fetches 
        we suspect the user has an invalid token. Because of this we are refreshing the 
        page so that we dont do a dos attack on backend!`
      );

      alert(i18n.global.t('@@translate@@ Apologies, due to some errors, we need to refresh the page!'));
      window.location.reload();
    }

    const authRequestBody = forced ? { forced_login: forced } : {};

    if (this.tokenFetchPromise && !forced) {
      loggerService.log('MM token was fetched already and it is not a forced call. Returning the promise instead!');
      return this.tokenFetchPromise;
    }

    this.authTokenFetchRetriesCount++;
    loggerService.log('Number of times mattermost token was fetched so far:', this.authTokenFetchRetriesCount);
    const tokenFetchPromise = backendApiClient
      .post(`/core/mattermost/login/`, authRequestBody)
      .then((response: any) => {
        if (!response?.data?.Token) {
          loggerService.warn('User is not logged in. Trying after 5 seconds!');
          loggerService.warn('Expected to get token in /core/mattermost/login response but got response', response);
          return new Promise((res, rej) => {
            setTimeout(() => {
              this.onUnauthorized().then(res).catch(rej);
            }, 5000);
          });
        }
        // return response.headers.get("token");
        this.token = response.data.Token;
      })
      .catch((err: any) => {
        loggerService.warn('error fetching mattermost token, refreshing the page!', err);
        alert(i18n.global.t(`@@translate@@ Apologies, due to an error we need to refresh the page!`));
        window.location.reload();
      });

    this.tokenFetchPromise = tokenFetchPromise;
    return tokenFetchPromise;
  }

  get trailingSlash(): string {
    return '';
  }
}

export default new MattermostApiClient();
